module.exports = __webpack_public_path__ + "img/emilija.50344ce7.jpeg";